import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { AppService } from "src/app/core/service/app.service";
import { AuthService } from "src/app/core/service/auth.service";
import { Constants } from "../../models/constants";
import { DmsDocument } from "../../models/dms-document";
import { UserAccount } from "../../models/user-account";
import { UserRole } from "../../models/user-role";

class CrossFieldErrorMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    return control.dirty && form.invalid;
  }
}

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.sass"],
})
export class ChangePasswordComponent implements OnInit {
  oldPasswordConfirmForm: FormGroup;
  changePasswordForm: FormGroup;
  ohide = true;
  nhide = true;
  chide = true;
  IsSuccess = false;
  constants: any;
  currentUser: UserAccount;
  newPassword: string;
  confirmPassword: string;
  oldPassword: string;
  userOldPassword: string;
  isOldPasswordVerify: boolean;
  userRole: UserRole;
  hide = true;
  dmsDocument: DmsDocument;
  hideOtpForm: boolean = false;
  hideChangePasswordForm: boolean = false;
  errorMatcher = new CrossFieldErrorMatcher();

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,
    private authService: AuthService
  ) {
    this.constants = Constants;
  }

  ngOnInit(): void {
    this.oldPasswordConfirmForm = this.formBuilder.group({
      oldpassword: ["", [Validators.required]],
    });
    this.changePasswordForm = this.formBuilder.group({
      newpassword: ["", Validators.required],
      cpassword: ["", Validators.required],
    });
    this.changePasswordForm.setValidators(this.passwordValidator);
    this.currentUser = JSON.parse(sessionStorage.getItem("CurrentUser"));
    this.getRole();
    this.spinner.hide();
    this.getProfilePicture(this.currentUser.ProfilePictureThumbId);
  }

  getProfilePicture(documentId) {
    const doc = { DocumentId: documentId };
    this.appService.getProfilePicture(doc).subscribe((res: any) => {
      if (!res.HasErrors) {
        this.dmsDocument = res;
      }
    });
  }

  public getSantizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  getRole() {
    const roleObj = { RoleId: this.currentUser.UserRoleId };
    this.appService.getRoleById(roleObj).subscribe({
      next: (res) => {
        if (!res.HasErrors) {
          this.userRole = res;
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  validateOldPassword() {
    if (this.oldPasswordConfirmForm.valid) {
      this.oldPassword = this.oldPasswordConfirmForm.get("oldpassword").value;
      this.spinner.show();
      const user = {
        UserAccountId: this.currentUser.Id,
        Password: this.oldPasswordConfirmForm.get("oldpassword").value,
      };
      this.appService.validateOldPassword(user).subscribe({
        next: (res) => {
          if (!res.HasErrors) {
            this.isOldPasswordVerify = true;
            this.hideChangePasswordForm = true;
            this.currentUser =
              res !== undefined && res !== null ? res : new UserAccount();
            this.changePasswordForm.reset();
            this.spinner.hide();
          } else {
            this.authService.showNotification(
              "snackbar-danger",
              res.Errors[0].Message,
              "top",
              "center"
            );
            this.isOldPasswordVerify = false;
            this.spinner.hide();
          }
        },
        error: (err) => {
          this.spinner.hide();
        },
      });
    }
  }

  checkPassword() {
    this.confirmPassword = this.changePasswordForm.get("cpassword").value;
    this.newPassword = this.changePasswordForm.get("cpassword").value;
    return this.changePasswordForm.get("newpassword").value ===
      this.changePasswordForm.get("cpassword").value
      ? true
      : false;
  }

  goBack() {
    this.appService.goBack();
  }

  confirmChangePassword() {
    if (this.changePasswordForm.valid && this.checkPassword()) {
      this.spinner.show();
      this.currentUser.Password = this.confirmPassword;
      this.currentUser.ModifiedById = this.currentUser.Id;
      this.currentUser.ModifiedBy =
        this.currentUser.FirstName + " " + this.currentUser.LastName;
      var userDetails = { UserDetails: this.currentUser };
      this.appService.ChangePassword(userDetails).subscribe({
        next: (res) => {
          if (!res.HasErrors) {
            this.changePasswordForm.reset();
            this.newPassword = null;
            this.oldPassword = null;
            this.confirmPassword = null;
            this.IsSuccess = true;
            this.isOldPasswordVerify = true;
            this.hideChangePasswordForm = true;
            sessionStorage.setItem(
              "CurrentUser",
              JSON.stringify(this.currentUser)
            );
            localStorage.setItem(
              "CurrentUser",
              JSON.stringify(this.currentUser)
            );
            // this.authService.showNotification(
            //   "snackbar-success",
            //   "Password changed successfully.",
            //   "top",
            //   "center"
            // );
            //   if (this.userRole.Prefix === "DC") {
            //     this.router.navigate(["/doctor/dashboard"]);
            //   }
            // } else if (this.userRole.Prefix == "PAD") {
            //   this.router.navigate(["/pharmacist/dashboard"]);
            // } else if (this.userRole.Prefix == "PSAD") {
            //   this.router.navigate(["/pharmacist/dashboard"]);
            //   // }
            //   this.spinner.hide();
            // } else {
            //   this.spinner.hide();
            // }
            this.spinner.hide();
          }
        },
        error: (err) => {
          this.spinner.hide();
        },
      });
    }
  }

  onSubmit() {
    this.hideOtpForm = true;
  }

  onChangePasswordSubmit() {
    this.hideChangePasswordForm = true;
  }
  get g() {
    return this.oldPasswordConfirmForm.controls;
  }
  gotoDashboard() {
    if (this.userRole.Prefix === "DC") {
      this.router.navigate(["/doctor/dashboard"]);
    } else if (this.userRole.Prefix == "PAD") {
      this.router.navigate(["/pharmacist/dashboard"]);
    } else if (this.userRole.Prefix == "PSAD") {
      this.router.navigate(["/pharmacist/dashboard"]);
    }
  }
  passwordValidator(form: FormGroup) {
    const condition =
      form.get("newpassword").value !== form.get("cpassword").value;

    return condition ? { passwordsDoNotMatch: true } : null;
  }
}
